<template>
    <div class="loading-bar" :style="style">
        <img :src="loadingImg" alt="">
    </div>
</template>
<script>
    import url from '../../../config/url';
    export default {
        props:{
            width: {
                type: String,
                default: "500px"
            },
            height: {
                type: String,
                default: "500px"
            }
        },
        data() {
            return {
                loadingImg: url.static + "/img/wj-loading.gif",
                style: 'width: ' + this.width +'; height: ' + this.height +';line-height: ' + this.height +';'
            }
        },
        created: function () {

        },
        mounted: function () {

        },
        methods: {}
    }
</script>

<style scoped lang="scss">
    @import "./../../../static/scss/page/loadingBar.scss";
</style>



// WEBPACK FOOTER //
// src/components/Utils/loadingBar.vue